<!--
  A share-of-total breakdown drawn as one stacked bar with a legend. It replaces CGS's Kendo pie
  charts (analysisOverviewChart, insightDemoChart), which take [{ title, count }].

  The data is the same and the percentages are the same: each slice is its count over the sum.
  As in CGS, all-zero data shows nothing (or emptyText).
-->
<template>
  <div class="ins-mix">
    <p v-if="title" class="ins-mix__title">{{ title }}</p>
    <template v-if="parts.length">
      <div class="ins-mix__bar" role="img" :aria-label="aria">
        <span v-for="(p, i) in parts" :key="p.label + i" :style="{ width: p.pct + '%', background: color(i) }" :title="`${p.label}: ${p.value} (${p.pct.toFixed(1)}%)`"></span>
      </div>
      <div class="ins-mix__legend">
        <span v-for="(p, i) in parts" :key="'l' + p.label + i"><i class="ins-mix__dot" :style="{ background: color(i) }"></i>{{ p.label }} {{ p.pct.toFixed(pctPlaces) }}%</span>
      </div>
    </template>
    <div v-else class="ins-empty" style="padding:8px 0;text-align:left">{{ emptyText }}</div>
  </div>
</template>

<script>
import { mixOf, MIX_PALETTE } from '@/helpers/insights/insightMath.js'

export default {
  name: 'MixBar',
  props: {
    title: { type: String, default: '' },
    points: { type: Array, default: () => [] },
    labelProp: { type: String, default: 'title' },
    valueProp: { type: String, default: 'count' },
    pctPlaces: { type: Number, default: 0 },
    emptyText: { type: String, default: 'No data for the selected date range.' }
  },
  computed: {
    parts() { return mixOf(this.points, { labelProp: this.labelProp, valueProp: this.valueProp }) },
    aria() { return `${this.title}: ` + this.parts.map(p => `${p.label} ${p.pct.toFixed(0)}%`).join(', ') }
  },
  methods: {
    color(i) { return MIX_PALETTE[i % MIX_PALETTE.length] }
  }
}
</script>
